let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3M7pT")).then(() => parcelRequire('eJjTT'));